import { siteInfo } from "@/mocks/site";

const points = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    desc: "不做泛资讯堆砌，只围绕「事件时间线」这一件事：把一条爆料从出现到落幕的全过程整理清楚，让读者不需要在多个平台之间来回比对。",
  },
  {
    icon: "ri-compass-3-line",
    title: "发展理念",
    desc: "相信可回溯比快更重要。我们宁愿晚几个小时发出，也要先把时间和来源标清楚，因为一次时间错位可能让整条时间线失去参考价值。",
  },
  {
    icon: "ri-book-open-line",
    title: "内容原则",
    desc: "当事各方说法并列呈现，更正过的内容不删除、只标注；涉及结论的部分，以可核查的公开材料为准，不做主观定性。",
  },
];

export default function BrandIntro() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <figure className="w-full h-[300px] md:h-[460px] rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20an%20open%20notebook%2C%20a%20magnifying%20glass%20and%20pinned%20notes%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20grid%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-about-01&orientation=landscape"
              alt="独家爆料编辑部整理事件时间线的工作台示意"
              title="独家爆料 · 时间线整理流程"
              className="w-full h-full object-cover object-top"
            />
          </figure>
          <div className="mt-4 grid grid-cols-2 gap-4">
            <div className="p-4 rounded-lg bg-background-100 border border-background-200">
              <p className="font-heading text-2xl font-bold text-foreground-950">1260</p>
              <p className="mt-1 text-xs text-foreground-500">在跟事件时间线</p>
            </div>
            <div className="p-4 rounded-lg bg-background-100 border border-background-200">
              <p className="font-heading text-2xl font-bold text-foreground-950">6</p>
              <p className="mt-1 text-xs text-foreground-500">长期跟踪方向</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-6">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-primary-700 uppercase">
              <span className="w-6 h-px bg-primary-400" />
              About Us
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              关于「{siteInfo.name}」：把零散爆料整理成看得懂的时间线
            </h2>
            <p className="mt-4 text-sm md:text-base leading-8 text-foreground-700">
              {siteInfo.name}是一个以事件时间线为核心的中文资讯站点。我们注意到，很多热点在传播过程中会不断被截断、重组，读者看到的往往只是某一个片段，很难判断哪条信息在先、哪条是后来的更正。
            </p>
            <p className="mt-3 text-sm md:text-base leading-8 text-foreground-700">
              所以我们只做一件事：为每条在跟的事件维护一条不断更新的时间线，把首发、更新、反转与后续四类节点按发生顺序排好，并保留各方说法与出处。读者可以只读摘要，也可以顺着时间线逐条看完，自己形成判断。
            </p>
          </div>

          <div className="flex flex-col gap-4">
            {points.map((item) => (
              <article
                key={item.title}
                className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="w-10 h-10 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0 text-lg">
                  <i className={item.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}